/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);

/* Throttle example
$(window).on('resize', $.throttle(500, function() {
    setCookieBarPosition();
  })
);
*/

jQuery(document).ready(function($) {

  $('#mm-trigger').on('click', function() {
    $('body').toggleClass('mm-open');
  });

  /* MOBILE MENU 2ND TIER --------------------------------------- */
  $('#menu-main-menu-1 > li.menu-item-has-children').each(function() {
    var $li = $(this);
    var $a  = $li.children('a').first();
    var $btn = $('<button class="mm-submenu-toggle" aria-expanded="false" aria-label="Expand submenu"></button>');
    $a.after($btn);
  });

  $(document).on('click', '#menu-main-menu-1 > li > .mm-submenu-toggle', function() {
    var $btn    = $(this);
    var $li     = $btn.closest('li');
    var isOpen  = $li.hasClass('is-open');
    $li.toggleClass('is-open', !isOpen);
    $btn.attr('aria-expanded', String(!isOpen));
  });


  /* SMOOTH SCROLLING ------------------------------------------- */
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href*="#modal"]').not('.event-category-filter a').click(function(t){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){

    var e = $(this.hash);

    // Determine the heights of possible elements on the page to take into consideration
    var header_height = $('#header').innerHeight(); // Fixed headers need to be taken into consideration
    
    var wpadminbar_height = ($('#wpadminbar').length > 0 ? $('#wpadminbar').innerHeight() : 0); // Height of WordPress admin bar
    var scroll_top_padding = 20; // Extra padding

    // Calculate the final offset for scrolling by removing the height of the items above (and some padding) from the total offset height
    var e_offset_top = e.offset().top - (header_height + wpadminbar_height + scroll_top_padding);

  (e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({
    scrollTop:e_offset_top
  },1e3,function(){var t=$(e);if(t.focus(),t.is(":focus"))return!1;t.attr("tabindex","-1"),t.focus()}))}});

});
